// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2KiAo","footer":"ModalInfo_footer__2XCIS"};